module.exports = __webpack_public_path__ + "img/spring_trip-20160416-14.22143bbe.jpg";